import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-lg text-center">
            <i className="fas fa-exclamation-triangle text-red-500 text-3xl mb-4" />
            <h2 className="text-xl font-semibold text-red-700 mb-2">
              {this.props.title || 'Error al cargar esta sección'}
            </h2>
            <p className="text-gray-600 mb-4">
              Ocurrió un error inesperado. Por favor, intenta recargar la página.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                if (this.props.onRetry) this.props.onRetry();
                else window.location.reload();
              }}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              data-testid="error-boundary-retry-btn"
            >
              <i className="fas fa-refresh mr-2" />
              Reintentar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
